module.exports = __webpack_public_path__ + "fonts/Lato-Thin.fe4e34a5.eot";